export const routes = {
  dashboard: "dashboard",
  onboarding: "onboarding",
  onboardingInfluencer: "start-onboarding",
  onboardingVaInfluencer: "va-onboarding",
  onboardingVaSelfServe: "va-onboarding-self-serve",
  onboardingInstagram: "instagram-onboarding",
  signIn: "sign-in",
  signUp: "sign-up",
  founder: "user",
  influencer: "start",
  tracking: "tracking",
  subscriptions: "subscriptions",

  // VA Path
  aboutVaOnboarding: "va-onboarding/about",
  categoryVaOnboarding: "va-onboarding/category",
  incomeOnboarding: "va-onboarding/income",
  vaIntroduction: "va-onboarding/va-introduction",
  vaPaidPortal: "va-onboarding/va-paid-portal",
  vaStepsToGetStarted: "va-onboarding/va-steps",
  vaOnboardingType: "va-onboarding/va-type",
  vaVideoOverview: "va-onboarding/va-video-overview",
  vaOnboardingNichePick: "va-onboarding/va-niche-pick",
  vaOnboardingNicheDetails: "va-onboarding/va-niche-details",
  vaOnboardingBackground: "va-onboarding/va-background",
  vaOnboardingSocials: "va-onboarding/socials",
  vaOnboardingFinalTouch: "va-onboarding/va-final-touch",
  vaFaq: "va-onboarding/va-faq",

  // Self Serve VA Path
  welcomeSelfServeOnboarding: "va-onboarding-self-serve/welcome",
  aboutSelfServeOnboarding: "va-onboarding-self-serve/about",
  nicheSelfServeOnboarding: "va-onboarding-self-serve/niches",
  templatesMethodSelfServeOnboarding:
    "va-onboarding-self-serve/templates/method",
  templatesFromScratchSelfServeOnboarding:
    "va-onboarding-self-serve/templates/from-scratch",
  templatesBentoAiSelfServeOnboarding:
    "va-onboarding-self-serve/templates/bento-ai",
  templatesCopyWriterSelfServeOnboarding:
    "va-onboarding-self-serve/templates/copywriter",
  faqSelfServeOnboarding: "va-onboarding-self-serve/faq",
  socialMediaLinksSelfServeOnboarding: "va-onboarding-self-serve/socials",

  // Non-VA Path
  welcomeOnboarding: "start-onboarding/welcome",
  aboutOnboarding: "start-onboarding/about",
  categoryOnboarding: "start-onboarding/category",
  templateMethodOnboarding: "start-onboarding/templates/method",
  templateBentoAiOnboarding: "start-onboarding/templates/bento-ai",
  templateFromScratchOnboarding: "start-onboarding/templates/from-scratch",
  socialMediaLinksOnboarding: "start-onboarding/socials",

  // Old Template FLows (for non-VA)
  pitchOnboarding: "start-onboarding/pitch",
  currentPitchOnboarding: "start-onboarding/current-pitch",
  pitchingGoalOnboarding: "start-onboarding/pitching-goal",
  pitchingHighlightOnboarding: "start-onboarding/highlights",
  portfolioOnboarding: "start-onboarding/portfolio",
  partnershipsOnboarding: "start-onboarding/partnerships",
  engagementOnboarding: "start-onboarding/engagement",
  standOutOnboarding: "start-onboarding/stand-out",
  draftTemplateOnboarding: "start-onboarding/template",
  recommendationOnboarding: "start-onboarding/recommendation",

  selectBrandOnboarding: "start-onboarding/select-brand",
  emailOnboarding: "start-onboarding/email-brand",

  // Demo Onboarding Path
  welcomeOnboardingDemo: "onboard/welcome",
  aboutOnboardingDemo: "onboard/about",

  // Instagram Onboarding
  preferencesInstagramOnboarding: "instagram-onboarding/preferences",
  signUpInstagramOnboarding: "instagram-onboarding/sign-up",
  signInInstagramOnboarding: "instagram-onboarding/sign-in",

  // Dashboard
  home: "dashboard/home",
  inbox: "dashboard/inbox",
  brands: "dashboard/brands",
  pitchLocal: "dashboard/local",
  opportunities: "dashboard/opportunities",
  settings: "dashboard/settings",
  profile: "dashboard/profile",
  templates: "dashboard/templates",
  pitchTrackerImport: "pitch-tracker/import",
  recommendations: "dashboard/recommendations",

  recommendationsSaved: "dashboard/recommendations/saved",
  recommendationsBento: "dashboard/recommendations/bento",
  actionItem: "/dashboard/home/action",

  // Tracking
  trackingView: "dashboard/tracking/view",

  // Campaigns
  campaignView: "dashboard/campaigns",

  // Templates
  create: "create",
  new: "new",
  import: "import",
  newTemplate: "new-template",

  // QuickSend
  outreachSend: "dashboard/outreach/send",
  discoverSend: "dashboard/brands/all/send",

  // OOO Collaboration
  pitchPlease: "pitch-please",
  pitchPleaseSignUp: "pitch-please/sign-up",
  pitchPleaseSignIn: "pitch-please/sign-in",

  // Pro Bundle
  proBundle: "pro-bundle",
  proBundleSignUp: "pro-bundle/sign-up",
  proBundleSignIn: "pro-bundle/sign-in",

  // VA Annual
  vaAnnual: "va-money-back",
  vaAnnualSignUp: "va-money-back/sign-up",
  vaAnnualSignIn: "va-money-back/sign-in",
};

export const isOnPage = (path: string) => {
  return window.location.href?.includes(path);
};

export type Route = {
  name: string;
  element: any;
};
